// src/components/TextInput.js
import React from 'react'

const TextInput = ({ label, name, value, onChange, placeholder }) => (
  <div className='form-group'>
    <label>{label}</label>
    <input
      type='text'
      className='form-control'
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required
    />
  </div>
)

export default TextInput
